import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Row, ContainerCol } from '../componentes_formulario/contenedores';
import ModalResponsive from '../componentes_formulario/modals/modalresponsive';
import ReactSelect from '../componentes_formulario/selects/react-select';
import {LabelForm} from '../componentes_formulario/labels/';



const ModalContainer = styled.div`
    margin-top: 20px;
    height: 400px;
    width: 600px;
`;

const Hr = styled.hr`
    margin-top: 10px;
    margin-bottom: 10px;
`;


//Styles
const outer = {
    width: '550px',
    margin:'auto'
};
const room={
    width: '550px',
    margin: '5px',
    float: 'left'
}
const messages= {
    width: '550px',
    margin:'5px',
    height: '300px',
    color:'black'
}
const itemMessage= {
    padding: '0',
    height: '250px',
    width:'550px', 
    overflowY: 'auto',
    overflowX:'auto'
}





//props principales : usuario, tipo
class ComponenteSolictudAprobacion extends React.Component{
    constructor(props){
        super(props);

        this.state = {
            mensaje: '',
            usuarioAprobador:null,
            mensajes:[],
        }
        this.handleInputChange = this.handleInputChange.bind(this)
        this.enviarSolicitud = this.enviarSolicitud.bind(this)
    } 
    handleInputChange(event){    
        const target = event.target;
        const name = target.name;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({
            [name]: value
        });
    }
    enviarSolicitud(){
        console.log(this.props)
        if(this.props.socket!==null){
            if(this.state.usuarioAprobador!==null){
                new Promise((resolve, reject) => {
                let objetoSolicitud ={};
                let fecha= new Date();
                objetoSolicitud.desde=this.props.socket.io.engine.id;
                objetoSolicitud.para= this.state.usuarioAprobador.value;
                objetoSolicitud.usuarioPara= this.state.usuarioAprobador.label;
                objetoSolicitud.usuarioLoginPara= (this.state.usuarioAprobador.usuario!==null && this.state.usuarioAprobador.usuario!==undefined)?this.state.usuarioAprobador.usuario:'';
                objetoSolicitud.usuarioDesde= this.props.usuario.NombreUsuario;

                objetoSolicitud.solicitud={
                    UsuarioSolicitante: this.props.usuario.NombreUsuario,
                    TransaccionId:this.props.transaccionId,
                    Fecha:fecha.getDate()+'/'+(fecha.getMonth()+1)+'/'+fecha.getFullYear(),
                    Hora:fecha.getHours()+':'+fecha.getMinutes()+':'+fecha.getSeconds(),
                    Tipo:this.props.tipo,
                    TipoMostrar:this.props.tipoMostrar,
                    Total_item: this.props.total_item,
                    Total_valor: this.props.total_valor
                }
                console.log(objetoSolicitud);
                this.props.socket.emit("enviarSolicitud",objetoSolicitud);
                resolve()
              })
            }else{
                alert('Debe seleccionar al usuario que desea solicitar aprobación.')
            }
        }
    }
    render(){
        return(
            <div>
                <ModalResponsive open={this.props.visible} onClose={this.props.onClose}>
                    <ModalContainer>
                        <Row>
                            <ContainerCol className='col-sm-12'>
                                <h4>{this.props.title}</h4>
                                <Hr />
                            </ContainerCol>
                        </Row>
                        <Row>
                            <ContainerCol className='col-sm-6' margen_arriba='15' margen_abajo='4'>
                                <LabelForm>Administradores Conectados:</LabelForm>
                                <ReactSelect options={ this.props.usuariosAprobadores } value={this.state.usuarioAprobador} func_onChange={(value)=>{this.setState({usuarioAprobador: value!==null?value:null})}}/>
                            </ContainerCol>
                        </Row>
                        <Row>
                        <div style={outer}>
                            <div style={room}>
                                <div style={messages} id="nMessages">
                                <ul style={itemMessage}>    
                                    {
                                        this.props.mensajes.map((message, i) => { 
                                            return (<li key={i}>
                                                        <span>
                                                            <strong>{message.fecha+'-'+message.hora+' '+message.desde}:</strong>
                                                            <br>
                                                            </br>
                                                            {message.mensaje}
                                                            <br>
                                                            </br>
                                                            {message.observacion}
                                                        </span>
                                                    </li>
                                                )
                                        })
                                    }
                                </ul>
                               
                                </div>   
                                <Row>                        
                                    <ContainerCol className='col-sm-12' >
                                    <div className='btn-group pull-right'>    
                                        <button type="button" className='btn btn-success btn-sm' disabled={!this.props.puedeSolicitar} onClick={()=>{this.enviarSolicitud()}}><i className="fa fa-paper-plane"></i>SOLICITAR APROBACIÓN</button>
                                    </div>
                                    </ContainerCol>
                                </Row>
        
                            </div>
                        </div>
                        </Row>            
                    </ModalContainer>
                </ModalResponsive>
            </div>
        );
    }
}

const mapStateToProps = ((state) => {
    return {
    };
});
  
export default connect (mapStateToProps)(ComponenteSolictudAprobacion);